import { AnimatedMarqueeHero } from "../../../components/ui/hero-3";
import { Link } from "react-router-dom";
import { RotatingHeroWord } from "../../../components/ui/rotating-hero-word";

const DEMO_IMAGES = [
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/003.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/002%20Done.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/Natural%20Language%20processing.png",
   "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/Deep%20Learning.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/Nesolearn%203D%20iPhone%20Mockup.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/Nesolearn%20Course%20Enrollment%203D%20iPhone%20Mockup.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/curios.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/machine%20learning%20with%20python.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/opencv.png",
    "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/511c5dca-ccb7-43f2-af31-f90cecb39cde_removalai_preview.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/60c049ba-cb39-4d6b-9845-3f1e4fce34d9_removalai_preview.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/68c7281f-e16d-4e64-b8b1-31f5d7cdba7e_removalai_preview.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/8293649e-ca48-4a44-b32c-7838577835c9_removalai_preview.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/9887d53e-9c73-4c30-b110-2cecd1771fd2_removalai_preview.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/9c20806a-e7a2-49ce-8c54-d2e12e430cf2_removalai_preview.png",
  "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/f769fcf2-29d1-40a9-8f6e-92fd05e9bf26_removalai_preview.png",
];

const NewHeroSection = () => {
  return (
    <AnimatedMarqueeHero
            tagline={
        <>
          SuperIntelligence for you, built right into Nesolearn{" "}
          <Link to="/for-institutions" className="font-bold text-red-500 hover:text-red-600 hover:underline">
            Learn more
          </Link>
        </>
      }
            title={
        <>
          <RotatingHeroWord />
          <span className="block mt-1 sm:mt-2">Now with AI</span>
        </>
      }
            description="Every course, badge, and skill you earn becomes a verifiable credential, secured on-chain so it can never be faked or lost. Built for learners who want proof that lasts, and institutions that need it trusted."
                  ctaText="Try Nesolearn for Free"
      ctaHref="/for-individuals"
      images={DEMO_IMAGES}
    />
  );
};

export default NewHeroSection;